import React, {useEffect} from 'react';
import {useNavigate} from "react-router";
import axios from 'axios';

import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button'; 
import Box from '@mui/joy/Box';
import Grid from '@mui/joy/Grid';

// My components
import StopCard 		from './stopCard.js';
import TrailingPercent 	from './trailingPercent.js';
import TrendBased 		from './trendBased.js';
import SaveProfit 		from './saveProfit.js';
import ATR 				from './ATR.js';
import Quote 			from './quote.js';
import Strength			from './strength.js';
import Sleep			from './sleep.js';

// Icons
import IcoLock 		from '@mui/icons-material/LockOutlined';
import IcoTrend	 	from '@mui/icons-material/TrendingUp';
import IcoPercent	from '@mui/icons-material/Percent';
import IcoATR 		from '@mui/icons-material/Insights';
import IcoQuote		from '@mui/icons-material/PriceChangeOutlined';
import IcoStrength	from '@mui/icons-material/RocketLaunchOutlined';
import IcoSnoozeIcon from '@mui/icons-material/Snooze';


import {stopData, stoplossType} from "./stopData.js";
import {config} from "./config.js";


function ChooseStops () {	
	const [isDisabled, setDisabled] = React.useState(true);
	const [isLoading, setLoading] = React.useState(false);
	const navigate = useNavigate();
	
	useEffect(() => {
		// Reset stopData
		console.log("Reset all stops");
		stopData.percentageBasedTrailing.valid = false;
		stopData.percentageBasedTrailing.percent = 0;
	
		stopData.trendBasedTrailing.valid = false;
		stopData.trendBasedTrailing.SMA = "";
	
		stopData.saveProfit.valid = false;
		stopData.saveProfit.percent = 0;
	
		stopData.ATR.valid = false;
		stopData.ATR.multiple = 0;
	
		stopData.quote.valid = false;
		stopData.quote.price = 0;
	
		stopData.strength.valid = false;
		stopData.strength.SMA = "";
		stopData.strength.percentage = 0;		
		
		stopData.sleep.valid = false;
		stopData.sleep.percent = 0;
		
	}, []);


	function uuidv4() {
	  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
	    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	  );
	}	
			
	
	function anyCardValid() {
		return stopData.percentageBasedTrailing.valid || stopData.trendBasedTrailing.valid || stopData.saveProfit.valid || stopData.ATR.valid || stopData.quote.valid || stopData.strength.valid || stopData.sleep.valid;
	}
	
	
	// ---- One 'handle-click' function for each stopcard

	function handleQuoteClick(valid, price) {
		
		console.log("valid", valid, "price", price);				

		stopData.quote.valid = valid;

		if (valid)
			stopData.quote.price = price;			

		setDisabled(!anyCardValid());
	}


	function handlePercentageBasedTrailingStopDataClick(valid, percent) {

		stopData.percentageBasedTrailing.valid = valid;

		if (valid)
			stopData.percentageBasedTrailing.percent = percent;			

		setDisabled(!anyCardValid());
	}

	
	function handleTrendBasedTrailingStopDataClick(valid, sma) {

		stopData.trendBasedTrailing.valid = valid;

		if (valid)
			stopData.trendBasedTrailing.SMA = sma;			

		setDisabled(!anyCardValid());
	}

	
	function handleSaveProfitClick(valid, percent) {

		stopData.saveProfit.valid = valid;

		if (valid)
			stopData.saveProfit.percent = percent;			

		setDisabled(!anyCardValid());
	}	


	function handleATRClick(valid, multiple) {
		console.log("valid", valid, "multiple", multiple);				
		
		stopData.ATR.valid = valid;
		
		if (valid)
			stopData.ATR.multiple = multiple;

		setDisabled(!anyCardValid());
	}	


	function handleStrengthClick(valid, percent, sma) {

		stopData.strength.valid = valid;
		
		if (valid) {
				stopData.strength.percent = percent;
				stopData.strength.SMA = sma;
		}

		setDisabled(!anyCardValid());
	}

	
	function handleSleepClick(valid, percent) {

		stopData.sleep.valid = valid;

		if (valid)
			stopData.sleep.percent = percent;			

		setDisabled(!anyCardValid());
	}
	
	
	// -----------------------------------------------------------------------	

	
	function createButtonClicked() {
        var rec = {};
        var requests = [];
        var url = config.IP + "/save2";
		let uid = localStorage.getItem("username");
        
        setLoading(true);
        
		// New user
		if (uid == "" || uid == null) {		
			uid = uuidv4();
			console.log("New user " + uid);			
			localStorage.setItem("username", uid);
		}

		console.log("Saving stops ---");

		// Set common props for all stops
        rec.userID      = uid;				        
        rec.companyName = stopData.stock.stockname;
        rec.ticker     	= stopData.stock.ticker;
        rec.price       = stopData.stock.buyprice;
        rec.created     = new Date().toISOString().substr(0, 10);
        rec.SMA200		= stopData.stock.SMA200;
        rec.SMA50		= stopData.stock.SMA50;
		rec.SMA20		= stopData.stock.SMA20;
		rec.ATR			= stopData.stock.ATR;

		if (stopData.stock.buyprice >= stopData.stock.marketprice)
        	rec.maxPrice = stopData.stock.marketprice;
        else
			rec.maxPrice = stopData.stock.buyprice;
			
		// Depending on stop type, set specific props
		if (stopData.percentageBasedTrailing.valid) {
			rec.stoplossType = stoplossType.Percent.id;
			rec.percent = stopData.percentageBasedTrailing.percent;
			
			requests.push(axios.post(url, rec));
		}

		if (stopData.quote.valid) {
			rec.stoplossType = stoplossType.Quote.id;
			rec.stoplossPrice = stopData.quote.price;
			
			requests.push(axios.post(url, rec));
		}

		if (stopData.trendBasedTrailing.valid) {
			if (stopData.trendBasedTrailing.SMA == 'SMA20') {
				rec.stoplossType = stoplossType.SMA20.id;
				requests.push(axios.post(url, rec));					
			}

			if (stopData.trendBasedTrailing.SMA == 'SMA50') {
				rec.stoplossType = stoplossType.SMA50.id;				
				requests.push(axios.post(url, rec));					
			}				
		}

		if (stopData.saveProfit.valid) {
			rec.stoplossType = stoplossType.SaveProfit.id;
			rec.percent = stopData.saveProfit.percent;
			requests.push(axios.post(url, rec));								
		}

		if (stopData.ATR.valid) {
			rec.stoplossType = stoplossType.ATR.id;
			rec.atrMultiple = stopData.ATR.multiple;
			rec.ATR	= stopData.stock.ATR;
			requests.push(axios.post(url, rec));								
		}

		if (stopData.strength.valid) {
			rec.stoplossType = stoplossType.Strength.id;
			rec.percent	= stopData.strength.percent;
			rec.sma	= stopData.strength.SMA;			
			requests.push(axios.post(url, rec));								
		}
		
		if (stopData.sleep.valid) {
			rec.stoplossType = stoplossType.Sleep.id;
			rec.percent = stopData.sleep.percent;
			
			requests.push(axios.post(url, rec));
		}		


		Promise.all(requests).then((responses) => {
		    console.log("Axios response create stops:", responses);

			// User has saved data, can be first visit so remeber we saved data 
			localStorage.setItem("datasaved", true);
		    
			setLoading(false);
			navigate('/showstops');
		})
		.catch(function(err) {
			console.log(err.message);
			setLoading(false);
			navigate('/error');
		});
							
	}
			    	
	return (
		<React.Fragment>
		
        <Typography level="h1" align="center"  mb={0} mt={3}>
			Available stops.
        </Typography>

        <Typography fontSize="lg" fontWeight="bold" align="center" mb={12}>
			Choose wisely...
        </Typography>
		
		
		<Grid
		  container
		  justifyContent = "center"
		  spacing={{ xs: 2, md: 3 }}
		  columns={{ xs: 1, sm: 3, md: 6 }}
		  sx={{ flexGrow: 1 }}
		  m={1}
		>

			<Grid>
				<StopCard handleClick={handlePercentageBasedTrailingStopDataClick} title={'Percentage-based trailing stop loss'} description={'Enter the percentage of how much your stock is allowed to fall from the highest value it has reached.'} icon={<IcoPercent style={{ color: stoplossType.Percent.color}}/>}>
					<TrailingPercent />
				</StopCard>
			</Grid>	


			<Grid>
				<StopCard handleClick={handleQuoteClick} title={'Fixed price stop loss'} description={'Enter the price level that, if breached, will trigger the stop.'} icon={<IcoQuote style={{ color: stoplossType.Quote.color}}/>}>
					<Quote />
				</StopCard>
			</Grid>	
			
	
			<Grid>
				<StopCard handleClick={handleTrendBasedTrailingStopDataClick} title={'Trend-based trailing stop loss'} description={'Choose the length of the trend you want to trail. When price goes below, stop is triggered.'} icon={<IcoTrend style={{ color: stoplossType.SMA20.color}}/>}>
					<TrendBased />
				</StopCard>
			</Grid>
	
	
			<Grid>
				<StopCard handleClick={handleSaveProfitClick} title={'Save profit'} description={'Alert me if my profit reaches the percentage below.'} icon={<IcoLock style={{ color: stoplossType.SaveProfit.color}}/>}>
					<SaveProfit />
				</StopCard>
			</Grid>


			<Grid>
				<StopCard handleClick={handleATRClick} title={'ATR-based trailing stop loss'} description={'Enter the ATR-multiple of how much your stock is allowed to fall from the highest value it has reached. (ATR14)'} icon={<IcoATR style={{ color: stoplossType.ATR.color}}/>}>
					<ATR />
				</StopCard>
			</Grid>			


			<Grid>
				<StopCard handleClick={handleStrengthClick} title={'Sell on strength'} description={'Enter percentage and SMA. Stop is triggered when price is percentage above chosen SMA.'} icon={<IcoStrength style={{ color: stoplossType.Strength.color}}/>}>
					<Strength />
				</StopCard>
			</Grid>			

			<Grid>
				<StopCard handleClick={handleSleepClick} title={'Sell on weakness'} description={'Enter percentage. Stop is triggered if price has not moved more than "percentage" in 3 weeks.'} icon={<IcoSnoozeIcon style={{ color: stoplossType.Sleep.color}}/>}>
					<Sleep />
				</StopCard>
			</Grid>			

		
		</Grid>
		    
			<Box sx={{flexGrow: 1, display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center', mt: 2}}>		    
				<Button size="lg" disabled={isDisabled} loading={isLoading} onClick={() => createButtonClicked()}>
					Create my stops
				</Button>
			</Box>
		    
		</React.Fragment>	
	);
}

export default ChooseStops;